import React from "react";
import styles from "./Style.module.css";
import { Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

function RatingTile({ title, value, tooltipText }) {
  return (
    <div className={styles.RatingWrap}>
      <div className={styles.title}>
      <div>{title}</div>

      {tooltipText && (
        <Tooltip title={tooltipText} placement="top">
          <InfoOutlinedIcon style={{ fontSize: ".975rem" }} />
        </Tooltip>
      )}
      </div>
      <div className={styles.value}>{value} </div>
    </div>
  );
}

export default RatingTile;